import { render, staticRenderFns } from "./TransactionsSubPurchasesTable.vue?vue&type=template&id=12f45b24"
import script from "./TransactionsSubPurchasesTable.vue?vue&type=script&lang=js"
export * from "./TransactionsSubPurchasesTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionsSubPurchasesTable.vue?vue&type=style&index=0&id=12f45b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports